<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">委托订单列表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" @keyup.enter.native="handleSearch" placeholder="请输入物料名称"></el-input>
      </el-form-item>
      <el-form-item label="委托订单">
        <el-input class="form-input" v-model="Search.OrderCode" @keyup.enter.native="handleSearch" placeholder="请输入委托订单编码"></el-input>
      </el-form-item>
      <el-form-item label="委托类型">
        <el-select v-model="Search.RepairType" filterable placeholder="请选择或输入委托类型" clearable>
          <el-option v-for="item in RepairTypes" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="Search.Region" filterable placeholder="请选择或输入区域" clearable>
          <el-option v-for="item in Regions" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tab" slot="tabs">
      <el-tabs class="tab" :value="activename" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="受托方待收货" name="Created"></el-tab-pane>
        <el-tab-pane label="受托方处理中" name="Receipted"></el-tab-pane>
        <el-tab-pane label="已完成" name="Compeleted"></el-tab-pane>
      </el-tabs>
    </div>
    <complex-grid v-loading="IsLoading" element-loading-text="加载中" :config="tableConfig" :data="tableData" slot="main-content">
      <template slot="sub-header" scope="props">
        <el-col :span="21">
          <span>{{props.row.CreateOn | date('YYYY-MM-DD HH:mm:ss')}}</span>
          <span style="margin-left: 20px">委托订单：{{props.row.Code}}</span>
          <span style="margin-left: 20px">委托类型：{{props.row.Type | EntrustType}}</span>
          <span style="margin-left: 20px">委托时长：{{props.row.EntrustDay}}天</span>
          <span style="margin-left: 20px">区域：{{props.row.RegionName}}</span>
        </el-col>
        <el-col :span="3">
          状态：
          <span style="color: red">{{props.row.State | EntrustState}}</span>
        </el-col>
      </template>
      <template slot="ProductName" scope="props">
        <p style="margin: 0">{{props.row.ItemName}}</p>
        <p style="margin: 4px 0 0">物料编码：{{props.row.ItemCode}}</p>
      </template>
      <template slot="ClientProductName" scope="props">
        <p style="margin: 0">{{props.row.CustomerItemName}}</p>
        <p style="margin: 4px 0 0">物料编码：{{props.row.CustomerItemCode}}</p>
      </template>
      <!-- <template slot="ProductConditionName" scope="props">
        <el-tag type="primary">{{props.row.ItemQualityName}}</el-tag>
      </template> -->
      <template slot="BrandName" scope="props">
        {{props.row.BrandName}}
      </template>
      <template slot="ModelName" scope="props">
        {{props.row.MachineName}}
      </template>
      <template slot="ModuleName" scope="props">
        {{props.row.ModuleName}}
      </template>
      <template slot="Number" scope="props">
        {{props.row.Quantity}}
      </template>
      <!-- <template slot="RentTime" scope="props">
        {{props.row.RentTime}}天
      </template> -->
      <template slot="Price" scope="props">
        {{props.row.Price}}
      </template>
      <template slot="action-bar" scope="props">
        <el-button type="text" @click.native="toDetail(props)">查看</el-button>
      </template>
    </complex-grid>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        OrderCode: null,
        OrderType: null,
        RepairType: null,
        Region: null,
      },
      OriginalOrderTypes: [
        { label: '入库单', value: 'InStockPicking' },
        { label: '租赁单', value: 'RentalOrder' },
        { label: '发货单', value: 'OutStockPicking' },
        { label: '内部调拨单', value: 'InternalStockPicking' },
        { label: '物流单', value: 'DeliveryOrder' },
        { label: '备用件退货单', value: 'DeliveryBackupReturn' },
        { label: '质检单', value: 'QcOrder' },
        { label: '租赁退货单', value: 'RentalReturnOrder' },
        { label: '租赁换货单', value: 'RentalExchangeOrder' },
        { label: '租赁维修单', value: 'RentalRepairOrder' },
        { label: '盘点单', value: 'InventoryOrder' },
        { label: '维修订单', value: 'RepairOrder' },
        { label: '维修单', value: 'RepairWorkOrder' },
        { label: '委外维修单', value: 'ExternalRepairWorkOrder' },
      ],
      IsLoading: false,
      activename: 'all',
      warehouseDate: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      Regions: [],
      RepairTypes: [
        { label: '只租', value: '1' },
        { label: '只售', value: '2' },
        { label: '可租可售', value: '3' },
      ],
      tableConfig: {
        dataPrefix: 'EntrustDetails',
        column: [
          {
            label: '物料名称／编码',
            width: '250px',
            slot: 'ProductName',
          },
          {
            label: '客户物料名称／编码',
            width: '250px',
            slot: 'ClientProductName',
          },
          // {
          //   label: '品项',
          //   width: '100px',
          //   slot: 'ProductConditionName',
          // },
          {
            label: '品牌',
            width: '80px',
            slot: 'BrandName',
          },
          {
            label: '机型',
            width: '150px',
            slot: 'ModelName',
          },
          {
            label: '模块',
            width: '100px',
            slot: 'ModuleName',
          },
          {
            label: '委托数量',
            width: '100px',
            slot: 'Number',
          },
          // {
          //   label: '委托时长',
          //   width: '100px',
          //   slot: 'RentTime',
          // },
          {
            label: '报价',
            width: '80px',
            slot: 'Price',
          },
          {
            label: '操作',
            collapse: true,
            key: 'action-bar',
            class: 'text-center',
            width: '160px',
          },
        ],
      },
      tableData: [],
      listURL: process.env.API_HOST + '/services/app/delegationService/AllEntrust',
    }
  },
  created() {
    this.handleSearch()
    this.initReion()
  },
  methods: {
    initReion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.Regions = data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    toDetail: function(props) {
      this.$router.push('/entrust/' + props.row.Code)
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      let states = 1
      if (this.activename === 'Created') {
        states = 1
      } else if (this.activename === 'Receipted') {
        states = 2
      } else if (this.activename === 'Compeleted') {
        states = 3
      }
      if (this.Search.OrderCode) {
        filters += '&entrustCode=' + this.Search.OrderCode
      }
      if (this.Search.Region) {
        filters += '&regionCode=' + this.Search.Region
      }
      if (this.Search.Product) {
        filters += '&ItemName=' + this.Search.Product
      }
      if (this.Search.RepairType) {
        filters += '&type=' + this.Search.RepairType
      }
      // filters.join('&')
      var URL = ''
      if (this.activename === 'all') {
        URL = this.listURL + '?pageIndex=' + this.currentPage + '&pageSize=' + this.pageSize + filters
      } else {
        URL = this.listURL + '?state=' + states + filters + '&pageIndex=' + this.currentPage + '&pageSize=' + this.pageSize
      }
      this.$http.get(URL).then((response) => {
        this.IsLoading = false
        this.tableData = response.data.items
        this.total = response.data.count
      }).catch((response) => {
        this.IsLoading = false
      })
    },
    handleTabClick({ name }) {
      this.activename = name
      this.handleSearch()
    },
    handleChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
  },
  components: {
    ListLayout,
    ComplexGrid,
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}

.list-layout .complex-table .sub-row-table .sub-body .text-center {
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

.main-content {
  .tab {
    .el-tabs__active-bar {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// EntrustListPage.vue?1a9fa9c4